import { AppBar, Box, Tab, Tabs, makeStyles } from '@material-ui/core';
import React, { useState, useRef, useEffect } from 'react'
import RoyaltyStatements from './RoyaltyStatements/RoyaltyStatements';
import CsvStatements from './CsvStatements/CsvStatements';
import { useLocation } from 'react-router-dom'
import { userAccessByType } from '../utils/AccessUtils';
import { useStoreContext } from '../../store/Store';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        minWidth: '1275px',
    },
    bar: {
        '& .MuiAppBar-colorPrimary': {
            backgroundColor: theme.palette.background.default,
        },
        '& .MuiPaper-elevation4': {
            boxShadow: 'none !important',
        },
        '& .MuiTabs-indicator': {
            display: 'none', 
        },
        "& .MuiButtonBase-root": {
            color: 'white',
            opacity: 1,
            font: 'normal normal bold 28px/21px Roboto',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            minWidth: 'auto',
            textTransform: 'none',
            paddingLeft: '0px',
            paddingRight: '0px',
            marginRight: '0px',
            position: 'relative',
        },
        "& .Mui-selected": {
            color: theme.palette.primary.main,
        },
        '& .MuiTabs-flexContainer': {
            columnGap: theme.spacing(3)
        },
        '& .MuiTabs-root': {
            '& .MuiTab-wrapper': {
                alignItems: 'start',
                position: 'relative',
                display: 'inline-block'
            }
        },
        marginBottom: theme.spacing(2),
    },
    tab: {
        width: 'auto !important',
        maxWidth: 'none !important',
    },
    customIndicator: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: '3px',
        backgroundColor: theme.palette.primary.main,
        transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    },
}));

const ReportingPage = () => {
    const location = useLocation();
    const styles = useStyles();
    const [state] = useStoreContext();
    const [tabValue, setTabValue] = useState(location.state?.tabValue || 0);
    const tabRefs = useRef([]);
    const indicatorRef = useRef(null);

    const [NavOptions] = useState([
        { label: "CSV Statements", tabProps: {}, component: <CsvStatements />, roles: [userAccessByType.USER_TYPE_ADMIN_ACCESS] },
        { label: "Reports", tabProps: {}, component: <RoyaltyStatements />, roles: [userAccessByType.USER_TYPE_ADMIN_ACCESS, userAccessByType.USER_TYPE_USER_ACCESS] },
    ].filter(x => x.roles.includes(state.user.userType)));

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        if (tabRefs.current[tabValue] && indicatorRef.current) {
            const activeTab = tabRefs.current[tabValue];
            const textNode = activeTab.querySelector('.MuiTab-wrapper');
            
            if (textNode) {
                const tabWidth = activeTab.offsetWidth;
                const tabLeft = activeTab.getBoundingClientRect().left;
                const tabsLeft = activeTab.parentElement.getBoundingClientRect().left;
                
                const leftPosition = tabLeft - tabsLeft;
                
                indicatorRef.current.style.width = `${tabWidth}px`;
                indicatorRef.current.style.left = `${leftPosition}px`;
            }
        }
    }, [tabValue, NavOptions]);

    return (
        <div className={styles.container}>
            <div className={styles.bar}>
                <AppBar position="static">
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        {NavOptions.map((tab, index) => (
                            <Tab
                                key={index}
                                label={tab.label}
                                className={styles.tab}
                                ref={el => tabRefs.current[index] = el}
                                {...tab.tabProps}
                            />
                        ))}
                        <div 
                            ref={indicatorRef}
                            className={styles.customIndicator}
                        />
                    </Tabs>
                </AppBar>
            </div>

            <Box>
                {NavOptions[tabValue]?.component}
            </Box>
        </div>
    )
}

export default ReportingPage